"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CardNavigation =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CardNavigation, _React$Component);

  function CardNavigation() {
    (0, _classCallCheck2["default"])(this, CardNavigation);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardNavigation).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardNavigation, [{
    key: "getColumnStyle",
    value: function getColumnStyle(type, value) {
      var _this$props = this.props,
          height = _this$props.height,
          textAlign = _this$props.textAlign;
      var baseStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: height,
        display: 'flex',
        alignItems: textAlign,
        justifyContent: 'center',
        padding: '1em'
      };
      return type === 'image' ? _objectSpread({}, baseStyle, {
        backgroundImage: "url('".concat(value, "')")
      }) : _objectSpread({}, baseStyle, {
        backgroundColor: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          itemsPerRow = _this$props2.itemsPerRow,
          items = _this$props2.items,
          gutter = _this$props2.gutter;
      return _react["default"].createElement(_semanticUiReact.Grid, {
        stackable: true,
        verticalAlign: "middle",
        columns: itemsPerRow
      }, items.map(function (_ref) {
        var background = _ref.background,
            content = _ref.content,
            link = _ref.link,
            type = _ref.type;
        return _react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: link,
          as: "a",
          href: link,
          style: !gutter ? _this.getColumnStyle(type, background) : {}
        }, gutter ? _react["default"].createElement("div", {
          style: _this.getColumnStyle(type, background)
        }, content) : content);
      }));
    }
  }]);
  return CardNavigation;
}(_react["default"].Component);

exports["default"] = CardNavigation;
CardNavigation.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    background: _propTypes["default"].string,
    backgroundType: _propTypes["default"].oneOf(['image', 'color']),
    content: _propTypes["default"].element,
    link: _propTypes["default"].string.isRequired
  })).isRequired,
  gutter: _propTypes["default"].bool,
  height: _propTypes["default"].number,
  itemsPerRow: _propTypes["default"].number,
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right'])
};
CardNavigation.defaultProps = {
  gutter: false,
  height: 300,
  itemsPerRow: 2,
  textAlign: 'center'
};